export const creditDecisionKeys = {
  all: ['creditDecisionMatrix'] as const,
  lists: () => [...creditDecisionKeys.all, 'list'] as const,
  detail: (companyId: string) => [...creditDecisionKeys.all, 'detail', companyId] as const,
}
